import BlogLayout from '../components/layout/BlogLayout';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import BlogItem from '../components/BlogItem';

export const AllBlogsQuery = graphql`
  query {
    allCosmicjsPosts(sort: { fields: [published_at], order: DESC }) {
      edges {
        node {
          title
          id
          slug
          content
          published_at(formatString: "DD MMMM, YYYY")
          metadata {
            post_author {
              title
            }
            tag {
              title
            }

            description
            main_image {
              url
            }
          }
        }
      }
    }
  }
`;

const Blog = ({ data }) => {
  return (
    <BlogLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kratos Gas &amp; Power Ohio | Kratos Ohio Blog</title>

        <meta
          name="description"
          content="Kratos Gas &amp; Power is a natural gas company for Ohio. Our natural gas experts are committed to providing your home or business with excellent service."
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link rel="canonical" href="https://ohio.kratosgp.com/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Kratos Gas &amp; Power Ohio | Kratos Ohio Blog" />
        <meta
          property="og:description"
          content="Kratos Gas &amp; Power is a natural gas company for Ohio. Our natural gas experts are committed to providing your home or business with excellent service."
        />
        <meta property="og:url" content="https://ohio.kratosgp.com/" />
        <meta property="og:site_name" content="Kratos Gas &amp; Power Ohio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          content="Kratos Gas &amp; Power is a natural gas company for Ohio. Our natural gas experts are committed to providing your home or business with excellent service."
        />
        <meta name="twitter:title" content="Kratos Gas &amp; Power Ohio | Kratos Ohio Blog" />
        <meta name="facebook-domain-verification" content="5b41f4enw35ff9sf4zkk2uhqyr2axk" />
        <link
          rel="icon"
          type="image/png"
          href="https://imgix.cosmicjs.com/672f0a90-c69e-11ea-8fc2-8d973b3e3b71-kratosfavicon.png"
        />
      </Helmet>
      <main class="mt-10 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
        <div class="mb-12 text-center border-b border-gray-400 md:pb-10 ">
          <h2 class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
            Kratos Ohio
            <br class="xl:hidden" />
            <span class="text-red"> Gas Blog</span>
          </h2>
        </div>

        {data.allCosmicjsPosts.edges.map(post => {
          return (
            <div>
              <BlogItem
                key={post.node.id}
                title={post.node.title}
                date={post.node.published_at}
                author={post.node.metadata.post_author.title}
                description={post.node.metadata.description}
                slug={post.node.slug}
                image={post.node.metadata.main_image.url}
                category={post.node.metadata.tag.map(tag => {
                  return <p className="pr-2">{tag.title + ','}</p>;
                })}
              />
            </div>
          );
        })}

        <div class="border-b border-gray-400"></div>
      </main>
    </BlogLayout>
  );
};

export default Blog;
